const SocialMediaEventType = {
  Transaction: 'Transaction',
  Listing: 'Listing',
  Review: 'Review',
  MortgageBrokerReview: 'MortgageBrokerReview',
  LeasingReview: 'LeasingReview',
  LeasingListing: 'LeasingListing',
  LeasingTransaction: 'LeasingTransaction',
  Award: 'Award',
} as const;

type SocialMediaEventType = (typeof SocialMediaEventType)[keyof typeof SocialMediaEventType];

export { SocialMediaEventType };

export function toSocialMediaEventType(eventType: string): SocialMediaEventType {
  // SAFETY(legacy): unreviewed, pre-dates this rule.
  return Object.keys(SocialMediaEventType).find((x) => x.toLowerCase() === eventType.toLowerCase()) as SocialMediaEventType;
}
